import { Component } from '@angular/core';

@Component({
  selector: 'app-onboarding-main',
  templateUrl: './onboarding-main.component.html',
  styleUrls: ['./onboarding-main.component.css']
})
export class OnboardingMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
